function changeSVGColor(color) {
  var heartIcon = document.getElementById("wishlist-heart-icon");

  var pathElement = heartIcon.querySelector("path");

  pathElement.setAttribute("fill", color);
}

function isProductInWishlist(shopId, productId) {
  var storageKey = "liv-wishlist-product-" + shopId;
  var tempArray = JSON.parse(localStorage.getItem(storageKey)) || [];

  for (var i = 0; i < tempArray.length; i++) {
    if (tempArray[i].id === productId) {
      changeSVGColor("red");
      break;
    }
  }
}
function addProductToWishlist(
  shopId,
  productId,
  productURL,
  productVendor,
  productTitle,
  productPrice,
  featured_picture
) {
  var product = {
    id: productId,
    URL: productURL,
    vendor: productVendor,
    title: productTitle,
    price: productPrice,
    picture_url: featured_picture,
  };

  var storageKey = "liv-wishlist-product-" + shopId;
  var tempArray = JSON.parse(localStorage.getItem(storageKey)) || [];

  var isProductInWishlist = tempArray.some(function (item, index) {
    if (item.id === productId) {
      tempArray.splice(index, 1);
      changeSVGColor("white");
      localStorage.setItem(storageKey, JSON.stringify(tempArray));
      return true;
    }
    return false;
  });

  if (!isProductInWishlist) {
    tempArray.push(product);
    localStorage.setItem(storageKey, JSON.stringify(tempArray));
    changeSVGColor("red");
  }
}
